// src/services/userService.js
import { useState, useEffect } from 'react';
import axios from 'axios';

const UserService = () => {
    const [userMap, setUserMap] = useState(new Map());

    useEffect(() => {
        const loadUsers = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL;
                const token = localStorage.getItem("token");
                const response = await axios.get(`${apiUrl}/users/list`, {
                    headers: { Authorization: `Bearer ${token}` }, // Assuming token is a Bearer token
                    params: { companyid: localStorage.getItem('companyid') } // Adjust based on auth
                });
                const userMap = new Map(response.data.users.map(user => [user.user_id, user.name]));
                setUserMap(userMap);
                console.log(`UserService loaded ${userMap.size} users`);
            } catch (error) {
                console.error('Error loading users:', error);
            }
        };
        loadUsers();
    }, []); // Run once on mount

    const getFullname = (userId) => {
        return userMap.get(userId) || 'NA';
    };

    return { getFullname };
};

export default UserService;